import React from 'react';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const DonationFailed = ({ donationData, onBackToHome, onRetry }) => {
  const handleBackToHome = () => {
    if (onBackToHome) {
      onBackToHome();
    } else {
      window.location.href = '/';
    }
  };

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.href = '/';
    }
  };

  return (
    <div className="min-h-screen bg-[#FFF8E6] flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8 text-center">
        {/* Failed Icon */}
        <div className="flex justify-center mb-6">
          <XCircle className="h-16 w-16 text-red-500" />
        </div>

        {/* Failed Message */}
        <h1 className="text-2xl font-source-serif-4 font-semibold text-[#67142D] mb-4">
          Payment Failed
        </h1>
        
        <p className="text-gray-600 mb-6">
          We're sorry, but your donation could not be processed at this time. This could be due to various reasons such as network issues, card problems, or payment gateway issues.
        </p>

        {/* Donation Details */}
        {donationData && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-red-800 mb-2">Failed Transaction Details</h3>
            <p className="text-sm text-red-700">
              <span className="font-medium">Amount:</span> ₹{donationData.amount}
            </p>
            {donationData.orderId && (
              <p className="text-sm text-red-700">
                <span className="font-medium">Order ID:</span> {donationData.orderId}
              </p>
            )}
            {donationData.reason && (
              <p className="text-sm text-red-700">
                <span className="font-medium">Reason:</span> {donationData.reason}
              </p>
            )}
          </div>
        )}

        {/* Help Message */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <p className="text-yellow-800 text-sm">
            <strong>Don't worry!</strong> Your card has not been charged. You can try again with the same or different payment method.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleRetry}
            className="w-full bg-[#67142D] text-white py-3 px-6 rounded-lg hover:bg-[#B51F3B] transition-colors flex items-center justify-center"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Try Again
          </button>
          
          <button
            onClick={handleBackToHome}
            className="w-full border border-gray-300 text-gray-700 py-3 px-6 rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-center"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </button>
        </div>

        {/* Additional Information */}
        <div className="mt-8 text-xs text-gray-500">
          <p className="mb-2">
            <strong>Common reasons for payment failure:</strong>
          </p>
          <ul className="text-left space-y-1">
            <li>• Insufficient funds in your account</li>
            <li>• Card expired or blocked</li>
            <li>• Network connectivity issues</li>
            <li>• Bank security restrictions</li>
          </ul>
          <p className="mt-4">
            For assistance, contact us at 
            <a href="mailto:support@vishwasanatan.org" className="text-[#67142D] hover:underline ml-1">
              support@vishwasanatan.org
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DonationFailed;
